import {BlackoutDateProps, NewBlackoutDateProps} from "../../../types/BlackoutPeriod";

export const blackoutPeriodFormValidator = (formValues: NewBlackoutDateProps, type: 1 | 2) => {
    const errors = [];
    if(type === 1) { // DAY TYPE
        if(!formValues.fromDay) {
            errors.push('Please select a starting day');
        }

        if(!formValues.toDay) {
            errors.push('Please select an end day');
        }

        if(formValues.fromDayTime === null || formValues.fromDayTime === undefined || formValues.fromDayTime < 0 || formValues.fromDayTime > 24) {
            errors.push('Please select the starting time for the Blackout Period');
        }
        if(formValues.toDayTime === null || formValues.toDayTime === undefined || formValues.toDayTime < 0 || formValues.toDayTime > 24) {
            errors.push('Please select the end time for the Blackout Period');
        }
    } else {
        if(!formValues.fromDate) {
            errors.push('Please select a starting day');
        }

        if(!formValues.toDate) {
            errors.push('Please select an end day');
        }

        if(formValues.fromDate && formValues.toDate && formValues.fromDate > formValues.toDate) {
            errors.push('Please make sure the dates you entered are valid (the From date should be earlier than To date)');
        }

        if(formValues.fromDateTime === null || formValues.fromDateTime === undefined || formValues.fromDateTime < 0 || formValues.fromDateTime > 24) {
            errors.push('Please select the starting time for the Blackout Period');
        }
        if(formValues.toDateTime === null || formValues.toDateTime === undefined || formValues.toDateTime < 0 || formValues.toDateTime > 24) {
            errors.push('Please select the end time for the Blackout Period');
        }
    }
    return errors;
}